import { Breadcumb, MainLayout } from 'components';
import ChangePassFrm from 'components/ChangePassFrm';
import Header from 'components/header/header';
import Loader from 'components/UI/loader/loader';
import React, { FC, useState } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { LoaderContainer } from './style';
import UserInfoService from '../../services/UserInfo/user-info';
import DarkAlert from 'components/DarkAlert';

const ChangePass: FC = () => {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = (formData, resetPasswordValidation) => {
    if (formData.confirmPass !== formData.newPass) {
      setAlertMessage(
        'Os campos de nova senha e confirmar senha precisam ser idênticos. Tente Novamente.',
      );
      setAlertOpen(true);
      return false;
    }

    if (!formData.confirmPass || !formData.newPass || !formData.pass) {
      setAlertMessage(
        'Você precisa preencher todos os campos. Tente Novamente.',
      );
      setAlertOpen(true);
      return false;
    }

    setIsLoading(true);
    UserInfoService.changePass(formData).then(
      () => {
        setAlertMessage('Senha alterada com sucesso');
        setAlertOpen(true);
        resetPasswordValidation();
      },
      (error) => {
        setAlertMessage(error?.data?.erro);
        setAlertOpen(true);
      },
    );
    setIsLoading(false);
  };

  return (
    <MainLayout>
      <Breadcumb />
      <Header />
      <Container>
        <Row>
          <Col>
            {isLoading && (
              <LoaderContainer>
                <Loader show={isLoading} />
              </LoaderContainer>
            )}
            <h2>Trocar Senha</h2>
            <ChangePassFrm
              onSubmit={(data, resetValidation) => onSubmit(data, resetValidation)}
            />
            <DarkAlert
              message={alertMessage}
              isOpen={alertOpen}
              onClose={() => {
                setAlertOpen(false);
              }}
            />
          </Col>
        </Row>
      </Container>
    </MainLayout>
  );
};

export default ChangePass;
